import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import AllBlogs from '../../components/AllBlogs';

export default function InsightsPage({
    global,
    all_news,
}) {
    return (
        <>
            <SeoHead
                page_name={`Career Advice | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
                canonical_link={`career-advice`}
            />
            <MainBanner
                global={global}
                pathPrefix={`career_advice_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>{"Career Advice"}</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                editableContent={false}
                displayImage1={false}
            />
            <AllBlogs
                global={global}
                pathPrefix={`news_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_news}
                ParentNews={false}
                enableFilterBy = {false}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const career_advice_tag = "Career Advice";

    const news = (await Collection('news'))
        .filter(function(post) {
            return (
                post.tag?.en.includes(career_advice_tag) && (post.country?.en == "United Kingdom" || post.country?.en == "All")
            )
        })

    const all_news = news.orderBy('publish_date').getItems();

    return {
        props: {
            global,
            all_news
        }
    };
}
